// extracted by mini-css-extract-plugin
export default {"row":"MicropilesSummary_row__9dMCF","table":"MicropilesSummary_table__oVchl","min120":"MicropilesSummary_min120__uO0No"};